import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon } from "../../../locales";
import { MemberServer } from "../../../server";
import { generateOperationFormConfig } from './config'

const server = MemberServer.Role;

const DEFAULT_OPERATION_DATA = {
    Name: null,
}

type OperateModeType = 'create' | 'modify'


export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('create');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode === 'modify' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(mode === 'create' ? server.create : server.modify, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(mode === 'create' ? langCommon?.createSuccess : langCommon?.modifySuccess);
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateOperationFormConfig({ formData, mode });
    }, [formData, mode]);

    return (
        <div>
            <Modal
                title={`${mode === 'create' ? langCommon?.create : langCommon?.modify}角色`}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Name, Id } = formData
                    const params = {
                        Name,
                        Id,
                    }
                    run(params)
                }}
            >
                <EditForm
                    componentId="role-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 6 },
                        wrapperCol: { span: 18 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
